import { capitalize } from 'lodash';

export const formatMessageableType = (messageableType) =>
  messageableType.split('_').map(capitalize).join(' ');
